import styled from "styled-components";

export default styled.h1`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
`;
